<template>
  <v-container fluid class="ma-0 pa-0">
    <!-- DESKTOP -->
    <v-expand-x-transition>
        <v-img
            v-if="false"
            class="d-none d-lg-block"
            width="70px"
            v-show="showLateral"
            style="z-index: 100; position: fixed; right: 0; top: 20%;"
            src="@/assets/covers/laterais.svg"
            eager
        />
        </v-expand-x-transition>

        <!-- MOBILE -->
        <v-expand-x-transition>
        <v-img
            class="d-lg-none"
            width="25px"
            v-show="showLateral"
            style="z-index: 100; position: fixed; right: 0; top: 70%;"
            src="@/assets/covers/laterais.svg"
            eager
        />
    </v-expand-x-transition>

    <!-- Intro -->
    <Intro/>

    
    <!-- Spacer -->
    <v-container fluid class="d-none d-lg-block bg-secondary py-12" />

    <!-- Team -->
    <TheTeam  class="py-16" />

    <!-- Divider -->
    <v-container fluid class="ma-0 pa-0">
      <v-container fluid class="ma-0 pa-0 bg-accent">
        <v-row class="ma-0 pa-0 d-none d-lg-block gradient-plan" style="background-color: #CBD3D4;" />
      </v-container>
    </v-container>

    <!-- Utility -->
    <YouArrived  id="utility" />

    <!-- Portfolio -->
    <Portfolio id="portfolio" />

    <!-- Divider -->
    <v-container fluid class="ma-0 pa-0">
      <v-container fluid class="ma-0 pa-0 bg-white">
        <v-row class="ma-0 pa-0 d-none d-lg-block gradient-plan" style="background-color: #9db5c9;" />
      </v-container>
    </v-container>

    <!-- Testimonials -->
    <Testimonials />

    <!-- Tecnologias -->
    <Technologies  id="technologies" class="py-16" />

    <!-- FAQ -->
    <FAQ id="faq" class="py-16" />

    <!-- Footer -->
    <PreFooter  />

  </v-container>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { useRoute } from 'vue-router'

import Intro from '@/views/Intro.vue'
import Technologies from '@/views/Technologies.vue'
import Portfolio from '@/views/Portfolio.vue'
import YouArrived from '@/views/YouArrived.vue'
import TheTeam from '@/views/TheTeam.vue'
import Testimonials from '@/views/Testimonials.vue'
import PreFooter from '@/views/PreFooter.vue'
import FAQ from '@/views/FAQ.vue'

const route = useRoute()
const showLateral = ref(false)

function handleScroll () {
  showLateral.value = window.scrollY > 370
}

function scrollToId (id) {
  if (!id) return
  nextTick(() => {
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handleScroll)
})

watch(
  () => route.params.place,
  (val) => scrollToId(val),
  { immediate: true }
)

function emailSender () {
  window.location.href = 'mailto:info@dreamdealtech.pt?subject=&body='
}
</script>

<style>
.test {
  background: url('../assets/covers/setas.svg') no-repeat;
  background-size: cover;
  background-size: 100%;
}

.line-1 {
  height: 2px;
  background: black;
  width: 50%;
  margin: auto;
}

@media (min-width: 850px) {
  .gradient-plan {
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0% 100%);
    height: 150px;
  }
}
</style>
